'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _linkWrapper = require('../../link-wrapper');

var _linkWrapper2 = _interopRequireDefault(_linkWrapper);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var render = function render(_ref) {
	var props = _ref.props;
	var url = props.url,
	    styleClasses = props.styleClasses,
	    target = props.target,
	    text = props.text;


	var attributes = {
		innerHTML: text,
		href: url,
		'data-style-attr': 'Link',
		class: styleClasses.Link
	};

	if (target) {
		attributes.target = '_blank';
		attributes.rel = 'noopener';
	}

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(_linkWrapper2.default, attributes), props);
}; /** @jsx dom */
exports.default = { render: render };